import { renderless, api } from "@opentiny/vue-renderless/carousel-item/vue";
import { defineComponent, props, setup as _setup } from "@opentiny/vue-common";
function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render) {
    options.render = render;
    options.staticRenderFns = staticRenderFns;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function hook2(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}

var __vue2_script = defineComponent({
  props: [].concat(props, ["name", "title", "label"]),
  setup: function setup(props2, context) {
    return _setup({
      props: props2,
      context,
      renderless,
      api
    });
  }
});
var render = function render2() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.state.ready,
      expression: "state.ready"
    }],
    staticClass: "tiny-carousel__item",
    class: {
      "is-active": _vm.state.active,
      "tiny-carousel__item--card": _vm.state.carouselParent.type === "card",
      "is-in-stage": _vm.state.inStage,
      "is-hover": _vm.state.hover,
      "is-animating": _vm.state.animating,
      "tiny-oblique": _vm.state.carouselParent.type === "card" && _vm.state.carouselParent.setUserCls
    },
    style: _vm.state.getTransform,
    on: {
      "click": _vm.handleItemClick
    }
  }, [_vm.state.carouselParent.type === "card" ? _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.state.active,
      expression: "!state.active"
    }],
    staticClass: "tiny-carousel__mask"
  }) : _vm._e(), _vm._t("default"), _vm.state.hasTitle ? _c("div", {
    staticClass: "item-title"
  }, [_c("span", [_vm._v(_vm._s(_vm.title))])]) : _vm._e()], 2);
};
var staticRenderFns = [];
var __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, render, staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (var o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var pc = /* @__PURE__ */ function() {
  return __component__.exports;
}();
export {
  pc as default
};
